import { render } from "./BasePieChart.vue?vue&type=template&id=040b3b5a&scoped=true"
import script from "./BasePieChart.vue?vue&type=script&lang=js"
export * from "./BasePieChart.vue?vue&type=script&lang=js"

import "./BasePieChart.vue?vue&type=style&index=0&id=040b3b5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040b3b5a"],['__file',"src/components/BasePieChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "040b3b5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('040b3b5a', __exports__)) {
    api.reload('040b3b5a', __exports__)
  }
  
  module.hot.accept("./BasePieChart.vue?vue&type=template&id=040b3b5a&scoped=true", () => {
    api.rerender('040b3b5a', render)
  })

}


export default __exports__